<template>
  <v-col class="offer__price pa-0">
    <span v-if="offers_count" class="d-none" :content="offers_count"/>
    <span class="d-none" content="Пластиковые окна"/>
    <div class="black-text old">
      <span :content="item.price_without_discount"  class="text-decoration-line-through">{{ item.price_without_discount.toLocaleString('ru').replace(/&nbsp;/g,' ') }}</span>
      <font-awesome-icon icon="ruble-sign" />
    </div>
    <v-badge
      bordered
      floating
      text-color="white"
      :content="item.discount + '%'"
      class="mt-2 mt-sm-0 color discount"
    >
      <v-tooltip aria-label="Подсказка о том, что это цена" position="bottom" open-delay="5000">
        <template v-slot:activator="{ props }">
          <div
            v-bind="props"
            role="status"
            class="transition-fast-in-fast-out mt-n1"
          >
            <span itemprop="price" class="text-red text" :content="item.price">{{ item.price.toLocaleString('ru').replace(/&nbsp;/g,' ') }}</span>
            <meta itemprop="priceCurrency" content="RUB"/>
            <font-awesome-icon icon="ruble-sign" class="text-red" />
          </div>
        </template>
        <span>{{ meta_tag }}</span>
      </v-tooltip>
    </v-badge>
  </v-col>
</template>
<script>
import { mapState } from "vuex";
import { railsData } from "../../init_data/rails_data.js";

export default {
  name: "TopPrice",
  data() {
    return {
      in_city: '',
      meta_tag: '',
    }
  },
  props: [
      "item",
  ],
  computed: mapState({
    offers_count: (state) => state.offers_count * 16,
  }),
  mounted() {
    if (railsData.city) { this.in_city = ` в ${ railsData.city.pattern_name }`; }
    if (railsData.page) {
      this.meta_tag = railsData.page.meta_tag
      if (railsData.page.city_for_tooltip) this.meta_tag = this.meta_tag + this.in_city;
    } else {
      this.meta_tag = `Цена на окна${this.in_city}`;
    }
  }
}
</script>
